module.exports = __webpack_public_path__ + "static/media/earn-draw-today.1a8630ea.png";